export const TrackAction = {
    LOGIN_CLICK: {
        Grafana: 'mainNavigation.konto-zaloguj',
        GA: 'click_menu',
        GA_Value: 'Zaloguj'
    },
    REGISTER_CLICK: {
        Grafana: 'mainNavigation.konto-zarejestruj',
        GA: 'click_menu',
        GA_Value: 'Zarejestruj'
    },
    FB_CLICK: {
        GA: 'click_menu',
        GA_Value: 'Zaloguj FB'
    },
    GOOGLE_CLICK: {
        GA: 'click_menu',
        GA_Value: 'Zaloguj Google'
    },
    EDIT_CLICK: {
        GA: 'click_menu',
        GA_Value: 'Edytuj dane'
    },
    ONE_LOGIN_CLICK: {
        GA: 'click_menu',
        GA_Value: 'Zaloguj One Login'
    },
};
